import React from 'react';
import { motion } from 'framer-motion';
interface HeroSectionProps {
  onOpenDemo: () => void;
}
export function HeroSection({
  onOpenDemo
}: HeroSectionProps) {
  return <section className="relative w-full pt-32 pb-20 md:pt-24 md:pb-32 bg-midnight-navy overflow-hidden" data-id="element-85">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="space-y-8 relative z-10" data-id="element-87">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="text-stark-white text-4xl md:text-6xl font-manrope font-bold leading-[1.1] tracking-tight" data-id="element-88">
            Stop Guessing Where Your Restaurant Money Is Going.
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: 'easeOut'
        }} className="text-stark-white/70 text-lg md:text-xl font-inter leading-relaxed max-w-xl" data-id="element-89">
            See your real food costs, labor costs, and spending — faster. ROI
            helps restaurant owners understand their money in, money out, and
            operational blind spots without waiting months for complicated
            setups.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-90">
            <button onClick={onOpenDemo} className="bg-accent-red text-stark-white px-8 py-4 rounded-full font-bold hover:bg-red-700 transition-all shadow-xl shadow-accent-red/20 active:scale-95" data-id="element-91">
              Book a Demo
            </button>
            <a href="#how-it-works" className="border border-stark-white/30 text-stark-white px-8 py-4 rounded-full font-bold hover:bg-white/10 transition-all text-center active:scale-95" data-id="element-92">
              See How It Works
            </a>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: 'easeOut'
      }} className="relative hidden md:block" data-id="element-93">
          <motion.svg animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} viewBox="0 0 500 500" className="w-full h-auto opacity-80" data-id="element-94">
            <defs data-id="element-95">
              <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-96">
                <stop offset="0%" style={{
                stopColor: '#E30B13',
                stopOpacity: 0.8
              }} data-id="element-97" />
                <stop offset="100%" style={{
                stopColor: '#091D32',
                stopOpacity: 0
              }} data-id="element-98" />
              </linearGradient>
            </defs>
            {/* Abstract data lines */}
            <path d="M50,250 Q150,50 250,250 T450,250" fill="none" stroke="url(#grad1)" strokeWidth="2" strokeDasharray="5,5" data-id="element-99" />
            <path d="M50,300 Q200,100 350,300 T500,100" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="1" data-id="element-100" />
            <circle cx="250" cy="250" r="100" fill="none" stroke="rgba(227, 11, 19, 0.2)" strokeWidth="1" data-id="element-101" />
            <circle cx="250" cy="250" r="150" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="1" data-id="element-102" />
            {/* Connecting dots */}
            <circle cx="150" cy="150" r="4" fill="#E30B13" data-id="element-103" />
            <circle cx="350" cy="350" r="4" fill="#E30B13" data-id="element-104" />
            <circle cx="250" cy="250" r="6" fill="#E30B13" data-id="element-105" />
            {/* Flow arrows */}
            <path d="M250,250 L280,280 M280,280 L270,280 M280,280 L280,270" stroke="#E30B13" strokeWidth="2" data-id="element-106" />
          </motion.svg>
        </motion.div>
      </div>
    </section>;
}